'use client';

import { trackEvent } from '@alltrails/amplitude/utils/track';
import Heading from '@alltrails/denali/components/Heading';
import Link from '@alltrails/denali/components/Link';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import Expandable from '../../../Expandable';
import { FooterLinksType } from '../../generateFooterLinks';
import styles from './styles.module.scss';

const MobileLink = ({ href, title, amplitudeEventName, childLinks = [] }: FooterLinksType) => (
  <Expandable
    iconColor="--color-text-primary-inverse"
    title={
      <Heading as="h2" className={styles.heading} size="300">
        <Link
          href={href}
          noUnderline
          onClick={() => {
            if (amplitudeEventName) {
              trackEvent(amplitudeEventName);
            }
          }}
          variant="inverse"
        >
          {title}
        </Link>
      </Heading>
    }
  >
    <ul>
      {childLinks.map(link => (
        <li key={link.title} className={styles.listItem}>
          <Link
            href={link.href}
            noUnderline
            onClick={() => {
              if (link.amplitudeEventName) {
                trackEvent(link.amplitudeEventName);
              }
            }}
            size="md"
            variant="inverse"
          >
            {link.title}
          </Link>
          {link.badge && <StatusBadge size={link.badge.size} text={link.badge.text} emphasis={link.badge.emphasis} variant={link.badge.variant} />}
        </li>
      ))}
    </ul>
  </Expandable>
);

export default MobileLink;
